import { MAX_TM_RATE } from '@clockwise/shared';

/**
 * Validation for a single service rate (dollars/hour). A rate is required
 * (must be > 0) and capped at the shared {@link MAX_TM_RATE}. Returns a
 * user-facing message, or null when valid.
 *
 * Shared by the SOW T&M line form and the rate-card editor — both set T&M
 * rates, so the bounds and messages must not drift between them. Keep this as
 * the single source of truth; do not inline another copy.
 */
export function rateError(rate: number): string | null {
  if (!(rate > 0)) return 'Enter a rate';
  if (rate > MAX_TM_RATE) return 'Cannot exceed 1,000.00';
  return null;
}
